import { post } from 'utils/network';
import { ApiRoute } from '../../utils/config';
import { Cart } from '../../models/cart.types';

// Applies given coupon code to logged out user cart if active
export const applyUserCoupon = async (couponCode: string,
  cart: Cart): Promise<Cart | undefined> => {
  const body = {
    id: cart.id,
    couponCode,
  };

  const {
    ok,
    parsedBody,
  } = await post<Cart>(`${ApiRoute.COUPONS}`, body);

  if (!ok) {
    throw new Error('Network response was not ok');
  }

  return parsedBody;
};
